
import { Prompt } from "@/lib/types";
import { usePromptLike } from "./use-prompt-like";
import { usePromptSave } from "./use-prompt-save";
import { usePromptEdit } from "./use-prompt-edit";
import { usePromptDelete } from "./use-prompt-delete";
import { usePromptReport } from "./use-prompt-report";

export const usePromptActions = (
  prompt: Prompt | null,
  user: any,
  onUpdate?: (id: string, updatedPrompt: Partial<Prompt>) => void,
  onDelete?: (id: string) => void,
  onUnsave?: () => void
) => {
  // Provide safe defaults when prompt is null
  const promptId = prompt?.id || '';
  const initialIsLiked = prompt?.isLiked || false;
  const initialLikes = prompt?.likes || 0;
  const initialIsSaved = prompt?.isSaved || false;

  const {
    isLiked,
    likeCount,
    handleLike,
    setIsLiked,
    setLikeCount
  } = usePromptLike(promptId, user, initialIsLiked, initialLikes);

  const {
    isSaved,
    handleSave,
    setIsSaved
  } = usePromptSave(promptId, user, initialIsSaved, onUnsave);

  const {
    isEditDialogOpen,
    setIsEditDialogOpen,
    handleEditSave
  } = usePromptEdit(prompt, user, onUpdate);

  const {
    isDeleteDialogOpen,
    isDeleting,
    setIsDeleteDialogOpen,
    handleDelete
  } = usePromptDelete(promptId, user, onDelete);

  const {
    isReportDialogOpen,
    isReporting,
    setIsReportDialogOpen,
    handleReport
  } = usePromptReport(promptId, user);

  return {
    isLiked,
    isSaved,
    likeCount,
    isEditDialogOpen,
    isDeleteDialogOpen,
    isReportDialogOpen,
    isDeleting,
    isReporting,
    setIsLiked,
    setIsSaved,
    setLikeCount,
    setIsEditDialogOpen,
    setIsDeleteDialogOpen,
    setIsReportDialogOpen,
    handleLike,
    handleSave,
    handleEditSave,
    handleDelete,
    handleReport
  };
};
